import * as actionTypes from '../actions/actionTypes';

const initialState = {
    token: localStorage.getItem('token'),
    addChatEnquirySettlementError:null,
    getChatEnquirySettlementError:null,
    payloadEnquirySettlement:[],

};

const chatroomEnquirySettlementReducer = (state = initialState, action) => {
    // console.log('action caseInformationEnquirySettlementReducer action: '+JSON.stringify(action))
    switch (action.type) {
        case actionTypes.ADD_Chat_MSG_EnquirySettlement:
            return {
                ...state,
                payloadEnquirySettlement: [...state.payload, '{username:'+action.username+',content:<p>'+action.content+'</p>,timestamp:<p>'+action.timestamp+'</p>}'],
                addChatEnquirySettlementError:false,
                getChatEnquirySettlementError:false,
            };
        case actionTypes.Error_ADD_Chat_MSG_EnquirySettlement:
            return {
                ...state,
                addChatEnquirySettlementError: action.addChatError,
            };
        case actionTypes.ERROR_GET_ALL_CHAT_MSG_EnquirySettlement:
            return {
                ...state,
                getChatEnquirySettlementError: action.getChatError,
            };
        case actionTypes.GET_ALL_CHAT_MSGS_EnquirySettlement:
            return {
                ...state,
                payloadEnquirySettlement: action.payloadEnquirySettlement,
                addChatEnquirySettlementError:false,
                getChatEnquirySettlementError:false,
            };
        default:
            return state;
    }
};

export default chatroomEnquirySettlementReducer;